var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.242 7.535"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.707.707l5.414 5.414L11.535.707",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "3debb224c4489e1b709f180a65ba395c.svg";
export { SvgFooterToggle as ReactComponent };